import React, { useEffect, useState } from "react";
import { Modal, Spin, Button, Popover} from "antd";
import { useDispatch } from "react-redux";
import { setPhysically, setNewPhysically } from "../../slices/riskSlice";

const TableCellPhysicallyNew = ({item, addNew}) => {

    const dispatch = useDispatch();
    const [physically2, setStatePhysically2] = useState("");
    const [checkedItem, setCheckedItem] = useState(null);
    const [checkedIdphysically, setCheckedIdphysically] = useState("");

	const [addPhysically2, setAddPhysically2] = useState(false);
    const [physically, setStatePhysically] = useState([]);
    const [physicallyArray, setStatePhysicallyArray] = useState([]);
    
    const [physicallyArrayUl, setStatePhysicallyArrayUl] = useState([]);

    return (
        <>
            {physicallyArray.map((element, index) => 
                <>
                    {element
                        &&
                        <div className={`hovers ${index}`}>
                            <ul style={{padding: '0', margin: '0'}}>
                                {
                                    // console.log(physicallyArrayUl)
                                    physicallyArrayUl.map((item, indx) =>
                                        (indx == index) && item.map((i, ind) =>
                                        i &&
                                        <li class="autofilss">
                                            <input type="text" className="autofilssInput" onChange={(e) => dispatch(setNewPhysically([index.toString(), ind, e.target.value ]))}></input>
                                        </li>
                                    ))
                                }
                                <div className="autofilss">
                                    <button onClick={(e) => {e.preventDefault(); setStatePhysicallyArrayUl(physicallyArrayUl.map((item, ind) => (ind == index) ? item = [...item, true] : item));}}>+ Add</button>
                                </div>  
                            </ul>
                        </div>   
                    }    
                </>
            )}
            <div className="autofilss">
                <button onClick={(e) => {e.preventDefault(); setStatePhysicallyArray([...physicallyArray, true]); setStatePhysicallyArrayUl([...physicallyArrayUl, [true]])}}>+ Add</button>
            </div>  
        </>
    )
};

export default TableCellPhysicallyNew;